import styled from 'styled-components';
import { space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { ellipsis } from 'polished';

export const Tag = styled.div`
  ${ellipsis()}
  ${space}
  display: inline-block;
  padding: 4px 8px;
  max-width: ${themeGet('tag.maxWidth')};
  font-size: ${themeGet('tag.fontSize')};
  line-height: ${themeGet('tag.lineHeight')};
  color: ${themeGet('tag.color')};
  background-color: ${themeGet('tag.backgroundColor')};
  border: ${themeGet('tag.border')};
  border-radius: ${themeGet('tag.borderRadius')};
  box-shadow: ${themeGet('tag.boxShadow')};
  cursor: pointer;

  &:hover {
    color: ${themeGet('tag.hover.color')};
    border: ${themeGet('tag.hover.border')};
    background-color: ${themeGet('tag.hover.backgroundColor')};
  }

  &:active {
    color: ${themeGet('tag.active.color')};
    border: ${themeGet('tag.active.border')};
    background-color: ${themeGet('tag.active.backgroundColor')};
  }
`;
